import React, {useState, useRef} from "react";
import AuthMenu from "./AuthMenu";
import GearMenus from "./GearMenus";
import HumbuggerMenu from "./Humberger/HumbuggerMenu";
import Logo from "./Logo";
import Menu from "./Menu";
import MuteButton from './/MuteButton';

const Header = ({ isTransparent = false, ual }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const audioRef = useRef(null);

  return (
    ual.activeUser ? 
      <div
        className={`${
          isTransparent ? "bg-transparent" : "bg-black"
        } custom-shadow fixed top-0 z-50 w-full`}
      >
        <div className="mr-2">
        <div className="flex items-center justify-between max-sm:gap-3">
          <Logo />
          <div className="flex grow items-center justify-evenly space-x-4">
            <Menu ual={ual} />
            <MuteButton audioRef={audioRef} />
            <AuthMenu isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} ual={ual} />            
            <GearMenus />
          </div>
          <HumbuggerMenu ual={ual} />
        </div>
        </div>
      </div>
    :
      <div
        className={`${
          isTransparent ? "bg-transparent" : "bg-black"
        } custom-shadow fixed top-0 z-50 w-full`}
      >
        <div className="mx-10">
          <div className="flex items-center justify-between">
            <Logo />
            <div className="flex grow items-center justify-evenly">
              <Menu ual={ual}/>
              <AuthMenu
                isAuthenticated={isAuthenticated}
                setIsAuthenticated={setIsAuthenticated}
                ual={ual}
              />
              <MuteButton audioRef={audioRef} />         
              <GearMenus/>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Header;
